import { reactive } from '@nuxtjs/composition-api';
export default function usePaymentInfo () {
  const payment = reactive({
    valid: false
  })
  return {
    payment
  }
}
